import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment:ENV = {
    production: true,
    apiUrl: 'https://rediperu.gateway.prod.redilatam.com/', //Prod
    ticketsUrl: '',
    mapsUrl: 'https://rediperu.gateway.prod.redilatam.com/', //para el módulo de mapas
    //vaucherUrl: 'https://balletruso.vouchers.prod.redilatam.com/',
    vaucherUrl: 'https://rediperu.tickets.prod.redilatam.com/',
    imagesServe: "https://rediperu.assets.prod.redilatam.com/",
    chatUrl: "https://rediperu.redi.prod.redilatam.com/",
    gatewayUrl: 'https://rediperu.gateway.prod.redilatam.com/redi/',
    type: 'rediperu',
    title: 'Redi Peru',
    subtitle: 'Membresías',
    description: `"Redi Bolivia" es un sitio en el que puedes administrar tus membresías, como las de socios, entradas y abonos.`,
    keywords: 'Redi Bolivia, campeon, clubbolivar, membresias, socios, abonos, entradas, tickets',
    yearProyect: '2025',
    imgLogoIcon: '/assets/img/isotipo.svg',
    imgLogoIconWhite: '/assets/img/isotipo-white.svg',
    imgLogo: '/assets/img/logo.png',
    imgLogoSVG: '/assets/img/isologo.svg',
    imgLogoWhiteSVG: '/assets/img/isologo-white.svg',
    imgLogoWhite: '/assets/img/logo-white.png',

    templateType: 'template-1',
    theme: 'light',
    changeTheme: false,

    version: '1.0.10',

    byDevelopment:'Desarrollado por Solunes Digital',

    authGoogle: false,
    authFacebook: false,
    authApple: false,
    authGithub: false,

    authRedirect: '',

    loaderType: 1,
    loaderDefaultText: 'Cargando...',

    //* Firebase
    firebase: {},

    keyEncript: '12345678901234567890123456789012',
    ivEncript: '1234567890123456',
};
